var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.584 20.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.614,1.651c.215-.221.475-.329.816-.325.35.004.628.115.861.336l2.6,2.571c.233.23.35.495.35.836,0,.345-.108.612-.332.839l-6.84,6.73-4.303-4.245L15.605,1.658l.009-.007h0ZM20.858,6.842l-7.225,7.11c-.054.078-.117.144-.197.194-.117.093-.26.141-.403.146l-3.783,1.152c-.233.072-.493.009-.672-.164l-.224-.217c-.063.06-.143.106-.233.135l-1.649.543c-.242.079-.511.017-.69-.161-.179-.177-.242-.44-.161-.678l.547-1.629c.036-.087.081-.167.143-.233l-.224-.215c-.17-.174-.233-.429-.161-.665l1.165-3.711v-.005c0-.173.063-.338.188-.462.036-.045.072-.086.117-.121L14.655.724C15.139.235,15.748-.007,16.448,0c.681.007,1.291.246,1.775.713h0l.009.007,2.618,2.576c.484.483.735,1.087.735,1.773,0,.679-.242,1.28-.717,1.765h0l-.009.008ZM11.732,13.301l-3.639-3.584-.771,2.454,1.918,1.888,2.492-.758Z",
    fill: "#01294e",
    fillRule: "evenodd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.066,13.594v4.407c0,.298-.126.582-.35.793-.202.188-.47.289-.751.311H2.628c-.317,0-.62-.118-.845-.328-.224-.211-.35-.495-.35-.793V5.432c0-.298.126-.582.35-.793.225-.21.528-.328.845-.328h3.752c.396,0,.717-.301.717-.672s-.321-.672-.717-.672h-3.752c-.697,0-1.366.26-1.859.722-.492.463-.769,1.09-.769,1.744v12.552c0,.654.277,1.281.769,1.744.493.462,1.162.722,1.859.722h10.328c.032.004.06.018.092.018h3.823c.697,0,1.366-.26,1.859-.722.492-.463.769-1.09.769-1.744v-4.407c-.244-.942-1.384-.798-1.434,0Z",
    fill: "#01294e",
    fillRule: "evenodd",
    strokeWidth: 0
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.ab006c045d3106869f4133057253aecd.svg";
export { ForwardRef as ReactComponent };